import "@babel/polyfill";
import "@/scripts/helpers/polyfills";
import {
  handleParsleyActions,
  handleFormActions,
  attachIE11helper,
  attachSafariBrowser,
  bindJQuery
} from "@/scripts/helpers/library";
import MobileMenu from "@/modules/navigations/mobile-menu/mobile-menu";
import Offcanvas from "@/modules/layout/offcanvas/offcanvas";
import Accordion from "@/modules/containers/accordion/old-accordion";
import {
  handleTrackMyAccount,
  handleUserInfoAction,
  handleTabletSearch,
  handleComboboxClose,
  usliSearchHeader
} from "@/modules/layout/page-header/page-header";
import { trackResponse } from "@/scripts/helpers/tracking";

import { generateLoaderMarkup } from "@/modules/components/loader";

import * as Sentry from "@sentry/browser";
import { Integrations as TracingIntegrations } from "@sentry/tracing";
import UslfSearch from "@/modules/components/uslf-search";
import { initChangeTabs } from "@/ui-kit/elements/ui-tab";
import { initUiToggle } from "@/ui-kit/elements/form-elements/ui-toggle";

const BUILD_TIME =
  new Date()
    .toDateString()
    .split(" ")
    .slice(1)
    .join(" ") +
  " " +
  new Date()
    .toTimeString()
    .split(" ")[0]
    .split(":")
    .map((it, id) =>
      id === 0
        ? +it + (new Date().getTimezoneOffset() === 0 ? -180 : 0) / -60
        : it
    )
    .join(":");

const handleAccountPageRedirect = () => {
  if ($(".js-account-link").length) {
    return $(".js-account-link").on("click", function(event) {
      const href = $(this).attr("href");

      if (
        href !== window.location.href &&
        window.location.pathname !== "/my-account/"
      ) {
        event.preventDefault();
        generateLoaderMarkup("layout-responsive", "global-loader");
        window.location = href;
      }
    });
  }

  return false;
};

bindJQuery();

/**
 * sendGlobalMetric is for track and send metrics from all the project pages by data attribute
 */
const sendGlobalMetric = () => {
  const metricSelector = $("[data-send-metric]");
  if (metricSelector) {
    metricSelector.on("click", function() {
      const metricName = $(this).attr("data-send-metric");

      trackResponse({
        name: metricName
      });
    });
  }
};

$(document).ready(function() {
  if (process.env.NODE_ENV === "production") {
    Sentry.init({
      dsn:
        "https://418e87fbe74e451c8a8af33ae0f8681b@o393202.ingest.sentry.io/5241899",
      release: `build #${process.env.BUILD_ID}`,
      environment: process.env.NODE_ENV,
      integrations: [new TracingIntegrations.BrowserTracing()],
      tracesSampleRate: 0.02
    });
  }

  // TODO: remove after refactoring and add init() from uslf-search for desktop & mobile search in header
  const mobileHeaderSearch = new UslfSearch("#mobile-search");
  const desktopHeaderSearch = new UslfSearch("#desktop-search");

  mobileHeaderSearch.init();
  desktopHeaderSearch.init();
  usliSearchHeader.init();
  Offcanvas();
  attachIE11helper();
  attachSafariBrowser();
  MobileMenu();
  Accordion();
  handleFormActions("subscribe-form", () => console.log("success"));
  handleUserInfoAction();
  handleTabletSearch();
  handleComboboxClose();
  handleParsleyActions();
  handleTrackMyAccount();
  handleAccountPageRedirect();
  sendGlobalMetric();
  initChangeTabs();
  initUiToggle();
});
